import styled, { css } from "styled-components";
import { Link } from "gatsby-link";
import Image from "components/Image";
import { media } from "../Theme/default-theme";

const defaultTextStyles = css`
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-size: 14px;
  text-decoration: none;
  width: fit-content;
  align-self: flex-start;
`;

const defaultLinkStyles = css`
  padding: 0.25em 0;
  margin: 0 0 0.5em;
  border-bottom: 1px solid transparent;
  word-break: break-word;

  :hover {
    border-bottom: 1px solid;
  }
`;

export const InternalLink = styled(Link)`
  ${defaultTextStyles}
  ${defaultLinkStyles}
  font-weight: 350;
`;

export const Copyright = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2.5px;
  margin: 0 0 5px;
`;

export const Legal = styled.div`
  p,
  ${InternalLink} {
    ${defaultTextStyles}
    font-weight: 400;
    font-size: 8px;
    margin: 0;
    padding: 0;
  }

  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 3em auto 0;
  width: auto;
  max-width: 95%;
`;

export const IconImage = styled(Image)`
  width: 100%;
  height: 100%;
  aspect-ratio: 3.5;
  max-width: 144px;
`;

export const ExternalLink = styled.a`
  ${defaultTextStyles}
  ${defaultLinkStyles}
  font-weight: 350;
`;

export const SectionLabel = styled.h3`
  ${defaultTextStyles}
  white-space: nowrap;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 11px;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Grid = styled.div`
  display: grid;
  width: 100%;
  gap: 1em;
`;

export const Column = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  height: 95%;
  margin: 0 auto;
  width: auto;
  max-width: 95%;
`;

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  background: #d9d9d9;
  padding: 4em 0;

  .link-section-container {
    grid-template-columns: repeat(2, minmax(100px, 1fr));

    .links-section {
      justify-content: flex-start;
    }
  }

  .app-links-container {
    gap: 0.5em;
  }

  ${media.tablet} {
    ${Content} {
      margin: 0 2.5em;
    }

    ${Legal} {
      margin: 2.5em;
    }

    .link-section-container {
      grid-template-columns: repeat(4, 1fr);
      max-width: fit-content;
      align-self: flex-start;
    }

    .app-links-container {
      gap: 0;
      flex-direction: column;
      align-self: flex-start;
      padding: 3em 0 0;

      .icon-button-link {
        max-width: 100px;
        max-height: 100%;
      }
    }
  }

  ${media.laptop} {
    ${Content} {
      flex-direction: row;
      justify-content: flex-start;

      .left-col {
        flex: 1;
        max-width: fit-content;
        align-self: flex-start;
      }

      .right-col {
        flex: 0 1 10%;
        align-self: flex-start;

        .app-links-container {
          padding: 0;

          .icon-button-link {
            max-width: 93px;
            max-height: 100%;
          }
        }
      }
    }
  }
`;
